<div class="card card--{{ variant }} card--theme-{{ theme }}"
    [style.background]="theme === 'custom' && customBackground ? customBackground : null">

    <!-- NÚMERO -->
    <div class="card__number" [style.display]="variant === 'number-title-body' ? 'block' : 'none'">
        <ng-content select="[card-number]"></ng-content>
        <h5 *ngIf="number">{{ number }}</h5>
    </div>

    <!-- IMAGEN -->
    <div class="card__image"
        [style.display]="(variant === 'image-hero' || variant === 'testimonial') ? 'block' : 'none'">
        <ng-content select="[card-image]"></ng-content>
        <img *ngIf="image" [src]="image" [alt]="imageAlt || ''" [title]="imageTitle || ''" />
    </div>

    <!-- QUOTE ICON START -->
    <span class="card__quote-icon" [style.display]="variant === 'testimonial' ? 'inline' : 'none'">&ldquo;</span>

    <!-- ICONO -->
    <div class="card__icon"
        [style.display]="(variant === 'icon-title-body' || variant === 'icon-title-body-author' || variant === 'icon-horizontal') ? 'flex' : 'none'"
        [ngClass]="{'card__icon--horizontal': variant === 'icon-horizontal'}">
        <ng-content select="[card-icon]"></ng-content>
        <i *ngIf="icon" [class]="icon"></i>
    </div>

    <!-- TÍTULO -->
    <div class="card__title">
        <ng-content select="[card-title]"></ng-content>
        <h3 *ngIf="title && (variant === 'title-subtitle-list' || variant === 'testimonial')">{{ title }}</h3>
        <h4
            *ngIf="title && (variant === 'simple' || variant === 'icon-title-body' || variant === 'icon-title-body-author' || variant === 'number-title-body' || variant === 'plan' || variant === 'icon-horizontal')">
            {{ title }}</h4>
        <h2 *ngIf="title && variant === 'image-hero'">{{ title }}</h2>
    </div>

    <!-- SUBTÍTULO -->
    <div class="card__subtitle" *ngIf="subtitle">
        <p>{{ subtitle }}</p>
    </div>
    <div class="card__subtitle card__subtitle--slot">
        <ng-content select="[card-subtitle]"></ng-content>
    </div>

    <!-- BODY -->
    <div class="card__body">
        <ng-content select="[card-body]"></ng-content>
    </div>

    <!-- FEATURES -->
    <div class="card__features" [style.display]="variant === 'plan' ? 'block' : 'none'">
        <ng-content select="[card-features]"></ng-content>
    </div>

    <!-- PRICE -->
    <div class="card__price" [style.display]="variant === 'plan' ? 'block' : 'none'">
        <ng-content select="[card-price]"></ng-content>
    </div>

    <!-- ACTION (botón de CTA para planes) -->
    <div class="card__action" [style.display]="variant === 'plan' ? 'block' : 'none'">
        <ng-content select="[card-action]"></ng-content>
    </div>

    <!-- FOOTER -->
    <div class="card__footer" *ngIf="footerText">
        <p class="card__footer-text">{{ footerText }}</p>
    </div>
    <div class="card__footer card__footer--slot">
        <ng-content select="[card-footer]"></ng-content>
    </div>

    <!-- AUTOR -->
    <div class="card__author" [style.display]="( variant === 'icon-title-body-author') ? 'block' : 'none'">
        <ng-content select="[card-author]"></ng-content>
        <div *ngIf="author">
            <p class="card__author-name">{{ author.name }}</p>
            <p class="card__author-role" *ngIf="author.role">{{ author.role }}</p>
        </div>
    </div>

    <!-- QUOTE ICON END -->
    <span class="card__quote-icon card__quote-icon--end"
        [style.display]="variant === 'testimonial' ? 'inline' : 'none'">&rdquo;</span>
</div>